import styled from 'styled-components';
import { H1, H2, B1, SectionParent } from '../../components/StyledComponents';
import React from 'react';
// import Check from '../../assets/v2/Hardware/TickHardware.svg';
import { LazyLoadImage } from 'react-lazy-load-image-component';
// import EnhancedBadge from '../../assets/v2/DigitalSignage/banner.svg';
import RightArrow from '../../assets/v2/Hardware/SideArrow.svg';
import LeftArrow from '../../assets/v2/Hardware/LeftSide.svg';
import ItemsCarousel from 'react-items-carousel';
import EnhancedBadge from '../../assets/v2/Hardware/enhanced-straight.svg';
import ValidatedBadge from '../../assets/v2/Hardware/validated-straight.svg';
import ReactSwipe from 'react-swipe';
import { StaticQuery, graphql, Link } from 'gatsby';
import { cleanupSlugs } from '../../globalFunctions';

const Section = styled(SectionParent)`
  background: #ffffff;
  padding-bottom: 7rem !important;
  padding-top: 5rem !important;
  @media (max-width: 1680px) and (min-width: 1440px) {
    padding: 0rem 8rem;
  }
  @media (max-width: 1440px) and (min-width: 768px) {
    padding: 0rem 8rem;
  }
  @media (max-width: 520px) {
    padding-bottom: 3rem !important;
  }
`;

const CarouselContainer = styled.div`
  display: flex;
`;
const imageStyle = {
  maxWidth: '100%',
  maxHeight: '100%',
  height: '100%',
  width: 'auto',
  alignSelf: 'center',
};
const GridItem = styled(Link)`
  grid-column: span 1;
  max-width: 10rem;
  /* flex: 0 0 calc(25%); */
  margin-top: 2rem;
  transition: transform 0.3s ease-in;
  background: red;
  width: fit-content;
  /* :hover {
    transform: scale(1.05);
    opacity: 0.8;
  } */
  position: relative;
  background: white;
  box-shadow: 0 1px 4px 0 rgba(66, 56, 128, 0.3);
  border-radius: 4px;
  /* margin-left: 12%; */
  cursor: pointer;
  position: relative;
  @media (max-width: 768px) {
    flex: 0 0 calc(100%);
    /* display: grid; */
    justify-items: center;
  }
  @media (max-width: 520px) {
    margin-left: 0.5rem;
  }
  @media (max-width: 400px) {
    min-width: unset;
    width: 100%;
    margin-left: 0;
  }
`;
const ImgContainer = styled.div`
  display: grid;
  justify-items: center;
  height: 15rem;
  padding: 2rem 1rem;
  @media (max-width: 768px) {
    min-width: 12rem;
  }
  @media (max-width: 520px) {
    padding: 1rem;
    height: 12rem;
    min-width: unset;
    max-width: unset;
  }
  @media (max-width: 350px) {
    max-width: 12rem;
    height: 8rem;
  }
`;

const GridTop = styled.div`
  min-height: 3rem;
`;

const GridBottom = styled.div`
  min-height: 3rem;
  background: #ffffff;
  padding: 1rem;
  width: 100%;

  display: grid;
  justify-content: center;
  align-items: center;
`;

const GridBottomText = styled(H2)`
  text-align: center;

  color: #000f16;
`;
const imageStyleTop = {
  width: '100%',
  marginTop: '6px',
};

const ImgContainerTop = styled.div`
  display: grid;
  width: 100%;
  justify-content: end;
  grid-column: span 1;
  right: 0;
  top: 6px;
`;
const ParentContainer = styled.div`
  margin: 6px 2rem;
  border-radius: 4px;
  box-shadow: 0 2px 4px 0 #8392aa;
  background-color: #ffffff;
  width: 75%;
  border-bottom: 6px solid #725cbd;
  @media (max-width: 800px) {
    width: 70%;
    margin: 6px 4rem;
  }
  @media (max-width: 520px) {
    width: 80%;
    margin: 6px 2rem;
  }
  @media (max-width: 400px) {
    margin: 6px 1.5rem;
  }
`;
const SectionHeading = styled(H1)`
  font-size: 42px !important;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  text-align: center;
  line-height: normal;
  letter-spacing: normal;
  color: #000f16;
  padding-bottom: 3rem;
  @media (max-width: 520px) {
    text-align: center;
    font-size: 24px;
  }
`;
const SectionSubHeading = styled(H2)`
  font-family: 'Nunito Sans', sans-serif;
  color: #7f8495;
  width: 40rem;
  font-weight: normal;
  @media (max-width: 600px) {
    width: fit-content;
  }
`;

const CarouselWrapper = styled.div`
  padding: 0 4rem;
  @media (max-width: 800px) {
    padding: 0 2rem;
  }
`;

const BottomImageContainer = styled.div`
  padding: 0.5rem 0;
  border-bottom: solid 1px #e8e8e8;
  display: grid;
  justify-content: center;
`;
const BottomImg = styled(LazyLoadImage)`
  max-width: 7rem;
`;
export default class DemoCarousel extends React.Component<any, any> {
  constructor(props: any) {
    super(props);
    this.state = {
      activeItemIndex: 0,
      items: 3,
    };
    this.resize = this.resize.bind(this);
  }
  componentDidMount() {
    window.addEventListener('resize', this.resize);
    this.resize();
  }

  resize() {
    if (window.innerWidth <= 1300) {
      this.setState({ items: 2 });
    }
    if (window.innerWidth <= 800) {
      this.setState({ items: 1 });
    }
    if (window.innerWidth >= 1300) {
      this.setState({ items: 3 });
    }
  }

  showBrandSpecific = (hardwareArray: any) => {
    const data = hardwareArray;
    const first = this.props.BrandName;
    data.sort((x: any, y: any) =>
      x.data.BrandLogo?.[0]?.data?.Name === first
        ? -1
        : y.data.BrandLogo?.[0]?.data?.Name === first
        ? 1
        : 0
    );
    return data;
  };

  showTypeSpecific = (hardwareArray: any) => {
    const type = this.props.Type;
    return this.showBrandSpecific(
      hardwareArray?.filter((item: any) => item?.data?.Type === type)
    );
  };

  changeActiveItem = (activeItemIndex: number) =>
    this.setState({ activeItemIndex });
  render() {
    return (
      <StaticQuery
        query={graphql`
          {
            esperEnhancedAndroid: allAirtable(
              filter: {
                data: { isEAA: { eq: true }, Published: { eq: true } }
                table: { eq: "Hardwares" }
              }
            ) {
              nodes {
                table
                id
                recordId
                data {
                  Name
                  OS {
                    data {
                      Name
                    }
                  }
                  Slugs
                  BrandLogo {
                    data {
                      Notes {
                        url
                      }
                      Name
                    }
                  }
                  Image {
                    url
                  }
                  Type
                }
              }
            }
            esperRecommended: allAirtable(
              filter: {
                data: { isEAA: { ne: true }, Published: { eq: true } }
                table: { eq: "Hardwares" }
              }
            ) {
              nodes {
                table
                id
                recordId
                data {
                  Name
                  OS {
                    data {
                      Name
                    }
                  }
                  Slugs
                  BrandLogo {
                    data {
                      Notes {
                        url
                      }
                      Name
                    }
                  }
                  Image {
                    url
                  }
                  Type
                }
              }
            }
          }
        `}
        render={(data: any) => (
          <Section>
            <SectionHeading>View similar products</SectionHeading>
            <CarouselWrapper>
              <ItemsCarousel
                // Placeholder configurations
                enablePlaceholder={true}
                // numberOfPlaceholderItems={
                //   data.esperValidatedAndroid.edges.length
                // }
                minimumPlaceholderTime={1000}
                // placeholderItem={
                //   <div style={{ height: 200, background: '#900' }}>
                //     Placeholder
                //   </div>
                // }
                // Carousel configurations
                numberOfCards={this.state.items}
                gutter={0}
                showSlither={false}
                firstAndLastGutter={true}
                freeScrolling={true}
                // Active item configurations
                requestToChangeActive={this.changeActiveItem}
                activeItemIndex={this.state.activeItemIndex}
                activePosition={'center'}
                chevronWidth={12}
                rightChevron={
                  <img src={RightArrow} style={{ height: '64px' }} />
                }
                leftChevron={<img src={LeftArrow} style={{ height: '64px' }} />}
                outsideChevron={true}
              >
                {!this.props.enhanced &&
                  this.showTypeSpecific(data.esperRecommended.nodes).map(
                    (item: any, index: number) => (
                      <ParentContainer
                        key={index}
                        style={{ borderBottom: '6px solid #66d1b1' }}
                      >
                        <GridItem
                          key={item.recordId + index}
                          to={`/hardware/${cleanupSlugs(item.data?.Slugs)}`}
                          style={{
                            borderBottom: '5px solid #66d1b1',
                            borderRadius: '4px',
                          }}
                        >
                          <GridTop>
                            <ImgContainerTop>
                              <LazyLoadImage
                                alt={'Esper Validated'}
                                src={ValidatedBadge}
                                style={imageStyleTop}
                              />
                            </ImgContainerTop>
                          </GridTop>
                          <ImgContainer>
                            <LazyLoadImage
                              alt={item.data.Name}
                              src={item.data.Image?.[0]?.url}
                              style={imageStyle}
                            />
                          </ImgContainer>
                          <BottomImageContainer>
                            <BottomImg
                              alt={'brand'}
                              src={
                                item.data.BrandLogo?.[0]?.data?.Notes?.[0]?.url
                              }
                              // style={imageStyleTop}
                            />
                          </BottomImageContainer>
                          <GridBottom>
                            <GridBottomText>{item.data.Name}</GridBottomText>
                          </GridBottom>
                        </GridItem>
                      </ParentContainer>
                    )
                  )}
                {this.props.enhanced &&
                  this.showTypeSpecific(data.esperEnhancedAndroid.nodes).map(
                    (item: any, index: number) => (
                      <ParentContainer key={index}>
                        <GridItem
                          key={item.recordId + index}
                          to={`/hardware/${cleanupSlugs(item.data?.Slugs)}`}
                          style={{
                            borderBottom: '5px solid #725cbd',
                            borderRadius: '4px',
                          }}
                        >
                          {/* {this.state.hover === index && (
                        <HoveringLayer>
                          <HoveringContent>
                            {item.node.tags
                              .slice(0, 4)
                              .map((tagItem: any, key: number) => (
                                <HoveringPoint
                                  style={key > 4 ? { display: 'none' } : {}}
                                  key={tagItem}
                                >
                                  {tagItem}
                                </HoveringPoint>
                              ))}
                          </HoveringContent>
                        </HoveringLayer>
                      )} */}
                          <GridTop>
                            <ImgContainerTop>
                              <LazyLoadImage
                                alt={'Esper Enhanced'}
                                src={EnhancedBadge}
                                style={imageStyleTop}
                              />
                            </ImgContainerTop>
                          </GridTop>
                          <ImgContainer>
                            <LazyLoadImage
                              alt={item.data.Name}
                              src={item.data.Image?.[0]?.url}
                              style={imageStyle}
                            />
                          </ImgContainer>
                          <BottomImageContainer>
                            <BottomImg
                              alt={'brand'}
                              src={
                                item.data.BrandLogo?.[0]?.data?.Notes?.[0]?.url
                              }
                              // style={imageStyleTop}
                            />
                          </BottomImageContainer>
                          <GridBottom>
                            <GridBottomText>{item.data.Name}</GridBottomText>
                          </GridBottom>
                        </GridItem>
                      </ParentContainer>
                    )
                  )}
              </ItemsCarousel>
            </CarouselWrapper>
          </Section>
        )}
      />
    );
  }
}
